import { render, staticRenderFns } from "./technical-support.vue?vue&type=template&id=aba3730a&scoped=true"
import script from "./technical-support.vue?vue&type=script&lang=js"
export * from "./technical-support.vue?vue&type=script&lang=js"
import style0 from "./technical-support.vue?vue&type=style&index=0&id=aba3730a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba3730a",
  null
  
)

export default component.exports